import { ESCAPE_PRIORITY, useEscapeAction } from '@peruselab/structure-editor/components';

// #525 -- the shared half of FileDrawer's and PeriodicTablePanel's Escape handling: a
// capture-phase document listener, live only while `active`, firing `onEscape` once per Escape
// press. Each caller's own extra behavior -- FileDrawer's Tab focus-trap lives in its own effect;
// PeriodicTablePanel's two-stage zoom-back-then-close is just logic inside its `onEscape` --
// stays with the caller. Only the listener skeleton itself was duplicated.
// #762 -- now an overlay entry in the shared escape arbiter, so an open drawer/panel closes before
// the canvas selection would clear, and an unfinished canvas gesture cancels first.
export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEscapeAction(
    ESCAPE_PRIORITY.overlay,
    () => {
      onEscape();
      return true;
    },
    active
  );
}
